// /* eslint-disable react-hooks/exhaustive-deps */
// import React, { useEffect, useMemo, useState } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import useStore from "../../../hooks/useStore";
// import Layout from "../../../utils/layout";
// import Performance from "../../../components/performance";
// import Financials from "../../../components/financials";
// import {
//   ApprovalEnums,
//   FINANCIALS_LABELS,
//   PERMISSBLE_LIMIT_GUIDANCE,
//   STATIC_GROUPS,
//   USER_ROLE,
// } from "../../../constants/constants";
// import DashboardHistogram from "../../../components/dashboard-chart/dashboard-histogram";
// import DynamicTable from "../../../datatable/DynamicTable";
// import { observer } from "mobx-react";
// import MobileTable from "../../../components/mobileTable/mobileTable";
// import PaginationControls from "../../../datatable/paginationControls";
// import { findKpi } from "../../../utils/helpers";
// import { Modal, Button } from "react-bootstrap";
// import { useAuth } from "../../../context/authProvider";
// import LogTableBody from "../logForms/environmentLog";

// const WaterDashboardPage = () => {
//   const [year, setYear] = useState(new Date().getFullYear());
//   const [page, setPage] = useState(1);
//   const [showModal, setShowModal] = useState(false);
//   const [modalType, setModalType] = useState(null);
//   const [selectedFormId, setSelectedFormId] = useState(null);

//   const navigate = useNavigate();
//   const {
//     userStore: { isLoggedIn, path, employeeKpis, user },
//     companyStore: { units, fetchUnits, kpiName },
//     formStore: { fetchForms, forms, approveForm, deleteForm, logRaw, logData },
//   } = useStore();

//   const { showAlert } = useAuth();

//   const kpi = useMemo(
//     () => findKpi({ kpis: employeeKpis, value: kpiName, field: "name" }),
//     [employeeKpis, kpiName]
//   );

//   const handleModalOpen = (type, formId) => {
//     setModalType(type);
//     setSelectedFormId(formId);
//     setShowModal(true);
//   };
//   const handleModalLogShow = async (formId) => {
//     await logData({ formId });
//     setModalType("log");
//     setShowModal(true);
//   };

//   const handleModalClose = () => {
//     setShowModal(false);
//     setSelectedFormId(null);
//     setModalType(null);
//   };

//   const handleConfirmAction = async () => {
//     if (selectedFormId) {
//       if (modalType === "approve") {
//         await approveForm({
//           formId: selectedFormId,
//           type: "water",
//           showAlert,
//           status: ApprovalEnums.Approved,
//           kpiName,
//           year,
//         });
//       } else if (modalType === "delete") {
//         await deleteForm({
//           formId: selectedFormId,
//           type: "water",
//           showAlert,
//           status: ApprovalEnums.Pending,
//           kpiName,
//           year,
//         });
//       }
//       handleModalClose();
//     }
//   };

//   const columns = React.useMemo(
//     () => [
//       { Header: "Sr No", Cell: ({ row: { _index } }) => _index + 1 },
//       {
//         Header: "Frequency Type",
//         Cell: ({
//           row: {
//             _original: { frequencyType },
//           },
//         }) => frequencyType || "-",
//       },
//       {
//         Header: "Frequency Date",
//         Cell: ({
//           row: {
//             _original: { frequencyDate },
//           },
//         }) => frequencyDate || "-",
//       },
//       {
//         Header: "Frequency Month",
//         Cell: ({
//           row: {
//             _original: { frequencyMonth },
//           },
//         }) => frequencyMonth || "-",
//       },
//       {
//         Header: "Frequency Year",
//         Cell: ({
//           row: {
//             _original: { frequencyYear },
//           },
//         }) => frequencyYear || "-",
//       },

//       {
//         Header: "Updated By",
//         width: 150,
//         Cell: ({
//           row: {
//             _original: { updater, creater, updatedAt },
//           },
//         }) => {
//           const updaterName = updater?.first_name
//             ? `${updater.first_name} ${updater.last_name}`
//             : creater?.first_name
//             ? `${creater.first_name} ${creater.last_name}`
//             : "-";
//           const formattedDate = updatedAt
//             ? new Date(updatedAt).toLocaleDateString("en-GB")
//             : "";

//           return (
//             <div>
//               <div>{updaterName}</div>
//               {formattedDate && (
//                 <div style={{ fontSize: "0.8em", color: "gray" }}>
//                   ({formattedDate})
//                 </div>
//               )}
//             </div>
//           );
//         },
//       },
//       {
//         Header: "Status",
//         Cell: ({
//           row: {
//             _original: { approvalStatus },
//           },
//         }) => (approvalStatus === "approved" ? "Approved" : "Pending" || "-"),
//       },
//       {
//         Header: "Approved By",
//         width: 150,
//         Cell: ({
//           row: {
//             _original: { approver, approvedAt },
//           },
//         }) => {
//           const approverName = approver?.first_name
//             ? `${approver.first_name} ${approver.last_name}`
//             : "-";
//           const formattedDate = approvedAt
//             ? new Date(approvedAt).toLocaleDateString("en-GB")
//             : "";

//           return (
//             <div>
//               <div>{approverName}</div>
//               {formattedDate && (
//                 <div style={{ fontSize: "0.8em", color: "gray" }}>
//                   ({formattedDate})
//                 </div>
//               )}
//             </div>
//           );
//         },
//       },
//       {
//         Header: "View",
//         Cell: ({
//           row: {
//             _original: { formId, approvalStatus },
//           },
//         }) => (
//           <span
//             onClick={() => {
//               navigate(isLoggedIn ? "/company/data" : "/admin/data", {
//                 state: { formId, page: "water", store: "waterStore" , approvalStatus: approvalStatus},
//               });
//             }}
//             className="btn btn-primary btn-sm btn-action waves-effect waves-light"
//           >
//             View
//           </span>
//         ),
//       },

//       {
//         Header: "Log",
//         Cell: ({
//           row: {
//             _original: { formId },
//           },
//         }) => (
//           <i
//             type="button"
//             onClick={() => handleModalLogShow(formId)}
//             className="mdi mdi-dots-vertical"
//           ></i>
//         ),
//       },

//       {
//         Header: "Actions",
//         width: 270,
//         Cell: ({
//           row: {
//             _original: { formId, approvalStatus },
//           },
//         }) => (
//           <div style={{ display: "flex", gap: "10px" }}>
//             {approvalStatus === ApprovalEnums.Approved ? (
//               <span>-</span>
//             ) : (
//               <>
//                 {user.role === USER_ROLE.Company || kpi.isApproved ? (
//                   <>
//                     <button
//                       className="btn btn-success btn-sm"
//                       onClick={() => handleModalOpen("approve", formId)}
//                     >
//                       Approve
//                     </button>
//                     <button
//                       className="btn btn-primary btn-sm btn-action waves-effect waves-light"
//                       onClick={() =>
//                         navigate("/company/approve/environment", {
//                           state: {
//                             formId,
//                             groupConstant: "water",
//                             type: "water",
//                             kpiName,
//                           },
//                         })
//                       }
//                     >
//                       Edit
//                     </button>
//                     <button
//                       className="btn btn-danger btn-sm"
//                       onClick={() => handleModalOpen("delete", formId)}
//                     >
//                       Delete
//                     </button>
//                   </>
//                 ) : (
//                   <>
//                     {kpi && (
//                       <>
//                         {kpi.isEdited && (
//                           <button
//                             className="btn btn-primary btn-sm btn-action waves-effect waves-light"
//                             onClick={() =>
//                               navigate("/company/approve/environment", {
//                                 state: {
//                                   formId,
//                                   groupConstant: "water",
//                                   type: "water",
//                                   kpiName,
//                                   year,
//                                 },
//                               })
//                             }
//                           >
//                             Edit
//                           </button>
//                         )}
//                       </>
//                     )}
//                   </>
//                 )}
//               </>
//             )}
//           </div>
//         ),
//       },
//     ],
//     [navigate, isLoggedIn, kpiName, kpi, user.role]
//   );

//   useEffect(() => {
//     fetchForms({ type: "water", page, pageSize: 10, filter: { year } });
//   }, [fetchForms, page, year]);

//   useEffect(() => {
//     fetchUnits();
//   }, [fetchUnits]);

//   const handleView = (formId) => {
//     navigate(isLoggedIn ? "/company/data" : "/admin/data", {
//       state: { formId, page: "water", store: "waterStore" },
//     });
//   };

//   const handleEdit = (formId) =>
//     navigate("/company/approve/environment", {
//       state: {
//         formId,
//         groupConstant: "water",
//         type: "water",
//         kpiName,
//         year,
//       },
//     });

//   return (
//     <Layout>
//       <div className="water-list">
//         <div className="container-fluid">
//           {/* Page Title */}
//           <div className="row">
//             <div className="col-12">
//               <div className="page-title-box d-sm-flex align-items-center justify-content-between">
//                 <h4 className="mb-sm-0 font-size-18">Water</h4>
//                 <div className="page-title-right">
//                   {isLoggedIn && (
//                     <div
//                       style={{
//                         display: "flex",
//                         marginLeft: "auto",
//                         width: "fit-content",
//                       }}
//                     >
//                       <div className="text-sm-end d-flex gap-1 flex-wrap">
//                         <Performance label="Water" />
//                         <Financials
//                           groups={["A", "B", "C"].map((ele) => ({
//                             group: ele,
//                             label: FINANCIALS_LABELS.water[ele],
//                           }))}
//                           guidance={PERMISSBLE_LIMIT_GUIDANCE}
//                           key="financials"
//                           units={units?.filter((e) =>
//                             ["Mega liter", "Kilo Liter", "Meter cube"].includes(
//                               e.name
//                             )
//                           )}
//                         />
//                         <Link to={`/${path}/add-water`}>
//                           <button
//                             type="button"
//                             data-bs-toggle="modal"
//                             data-bs-target="#newCustomerModal"
//                             className="btn btn-secondary waves-effect waves-light addCustomers-modal "
//                           >
//                             <i className="mdi mdi-plus me-1"></i> Add water
//                           </button>
//                         </Link>
//                       </div>
//                     </div>
//                   )}
//                 </div>
//               </div>
//             </div>
//           </div>
//           {/* End Page Title */}

//           <div
//             style={{
//               display: "flex",
//               flexWrap: "wrap",
//               gap: "20px",
//             }}
//           >
//             {Object.entries(STATIC_GROUPS.water).map(
//               ([group, title], index) => (
//                 <div
//                   style={{
//                     flex: "1 1 calc(50% - 20px)",
//                     boxSizing: "border-box",
//                   }}
//                   key={group}
//                 >
//                   <DashboardHistogram
//                     index={index}
//                     title={title}
//                     group={group}
//                     reportType="water"
//                   />
//                 </div>
//               )
//             )}
//           </div>
//           <div className="row mt-4">
//             <div className="col-12">
//               <div className="card">
//                 <div className="card-body">
//                   <div className="row mb-2 align-items-center">
//                     <div className="col-xl-3">
//                       <label className="form-label">
//                         Filter data on Annual basis
//                       </label>
//                       <select
//                         className="form-select"
//                         value={year || new Date().getFullYear()}
//                         onChange={(event) =>
//                           setYear(Number(event.target.value))
//                         }
//                       >
//                         {Array.from({ length: 5 })
//                           .map((_, i) => new Date().getFullYear() - i)
//                           .map((v) => (
//                             <option key={v} value={v}>{`FY ${v}-${
//                               v + 1
//                             }`}</option>
//                           ))}
//                       </select>
//                     </div>
//                   </div>
//                   <div className="table  dashboard-table">
//                     <DynamicTable
//                       pageSize={forms?.records?.length || 0}
//                       columns={columns}
//                       data={forms?.records || []}
//                     />
//                   </div>
//                   <MobileTable
//                     handleModalOpen={handleModalOpen}
//                     handleView={handleView}
//                     handleEdit={handleEdit}
//                   />
//                   <PaginationControls
//                     totalPages={forms?.totalPages}
//                     page={page}
//                     setPage={setPage}
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//         {/* Existing component code */}

//         <Modal
//           show={showModal}
//           onHide={handleModalClose}
//           size={modalType === "log" ? "xl" : ""}
//           centered
//         >
//           <Modal.Header closeButton>
//             <Modal.Title>
//               {modalType === "approve"
//                 ? "Approve Form"
//                 : modalType === "delete"
//                 ? "Delete Form"
//                 : "Log Details"}
//             </Modal.Title>
//           </Modal.Header>
//           <Modal.Body style={{ overflow: "hidden" }}>
//             {modalType === "approve" && (
//               <p>Are you sure you want to approve this form?</p>
//             )}
//             {modalType === "delete" && (
//               <p>
//                 Are you sure you want to delete this form? Once deleted, all
//                 data associated with this form will be permanently removed and
//                 cannot be recovered.
//               </p>
//             )}
//             {modalType === "log" && (
//               <div style={{ overflowX: "auto" }}>
//                 <table className="table table-responsive scroll">
//                   <thead>
//                     <tr key={12} className="waterTabletr">
//                       <th key={0}>Username</th>
//                       <th key={1}>Date</th>
//                       <th key={2}>Action</th>
//                       <th key={3}>Ip</th>
//                       <th key={4}>Request</th>
//                     </tr>
//                   </thead>
//                   <LogTableBody logRaw={logRaw} formId={selectedFormId}/>
//                 </table>
//               </div>
//             )}
//           </Modal.Body>

//           <Modal.Footer>
//             <Button variant="secondary" onClick={handleModalClose}>
//               Cancel
//             </Button>
//             {modalType === "approve" && (
//               <Button variant="primary" onClick={handleConfirmAction}>
//                 Approve
//               </Button>
//             )}
//             {modalType === "delete" && (
//               <Button variant="primary" onClick={handleConfirmAction}>
//                 Delete
//               </Button>
//             )}
//           </Modal.Footer>
//         </Modal>
//       </div>
//     </Layout>
//   );
// };

// export default observer(WaterDashboardPage);


/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import useStore from "../../../hooks/useStore";
import Layout from "../../../utils/layout";
import Performance from "../../../components/performance";
import Financials from "../../../components/financials";
import {
  ApprovalEnums,
  FINANCIALS_LABELS,
  PERMISSBLE_LIMIT_GUIDANCE,
  STATIC_GROUPS,
  USER_ROLE,
} from "../../../constants/constants";
import DashboardHistogram from "../../../components/dashboard-chart/dashboard-histogram";
import DynamicTable from "../../../datatable/DynamicTable";
import { observer } from "mobx-react";
import MobileTable from "../../../components/mobileTable/mobileTable";
import PaginationControls from "../../../datatable/paginationControls";
import { findKpi } from "../../../utils/helpers";
import { Modal, Button } from "react-bootstrap";
import { useAuth } from "../../../context/authProvider";
import LogTableBody from "../logForms/environmentLog";
// Import xlsx for Excel generation
import * as XLSX from 'xlsx';
import { when } from "mobx";
import { runInAction } from "mobx";


const WaterDashboardPage = () => {
  // ...existing code...

  // Log the water data shown in the table
  const [year, setYear] = useState(new Date().getFullYear());
  const [page, setPage] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState(null);
  const [selectedFormId, setSelectedFormId] = useState(null);
  const [yearType, setYearType] = useState("financial"); // "calendar" or "financial"

  const [isExcelLoading, setIsExcelLoading] = useState(false);

  const navigate = useNavigate();
  const {
    userStore: { isLoggedIn, path, employeeKpis, user },
    companyStore: { units, fetchUnits, kpiName,companyUnit , catId, subCatId, kpiId,assignUnitsRaw, fetchAssignUnits, getCompanyUnitName},
    formStore: { fetchForms, forms, approveForm, deleteForm, logRaw, logData,data,getFormData,  fetchFields,
      fields, fetchFieldsForExcel},
    waterStore: { fetchWaterByYear, waterDataByYearList } // Add waterStore
  } = useStore();

  const { showAlert } = useAuth();

  const kpi = useMemo(
    () => findKpi({ kpis: employeeKpis, value: kpiName, field: "name" }),
    [employeeKpis, kpiName]
  );

    useEffect(() => {
      if (!assignUnitsRaw?.length) {
        fetchAssignUnits();
      }
    }, [assignUnitsRaw]);



  const handleModalOpen = (type, formId) => {
    setModalType(type);
    setSelectedFormId(formId);
    setShowModal(true);
  };
  const handleModalLogShow = async (formId) => {
    await logData({ formId });
    setModalType("log");
    setShowModal(true);
  };

  const handleModalClose = () => {
    setShowModal(false);
    setSelectedFormId(null);
    setModalType(null);
  };

  const handleConfirmAction = async () => {
    if (selectedFormId) {
      if (modalType === "approve") {
        await approveForm({
          formId: selectedFormId,
          type: "water",
          showAlert,
          status: ApprovalEnums.Approved,
          kpiName,
          year,
        });
      } else if (modalType === "delete") {
        await deleteForm({
          formId: selectedFormId,
          type: "water",
          showAlert,
          status: ApprovalEnums.Pending,
          kpiName,
          year,
        });
      }
      handleModalClose();
    }
  };



 
  const getFinancialYearDateRange = (year) => {
    return {
      startMonth: 4, // April
      startYear: year,
      endMonth: 3, // March
      endYear: year + 1,
    };
  };
  
  

 
 

  


//financial year
//changes to display all the fieldnames also
// const handleExcelDownload = async () => {
//   setIsExcelLoading(true);

//   try {
//     const startYear = year;
//     const endYear = year + 1;

//     const waterData = await fetchWaterByYear({ startYear, endYear, showAlert });
//     const approvedForms = forms?.records?.filter(f => f.approvalStatus === "approved") || [];

//     if (approvedForms.length === 0) {
//       showAlert("No approved forms found");
//       return;
//     }

//     const approvedFormIds = approvedForms.map(f => f.formId);
//     const approvedData = (waterData || []).filter(d => approvedFormIds.includes(d.formId));

//     if (approvedData.length === 0) {
//       showAlert("No approved data found for selected year");
//       return;
//     }

//     const fullStructure = await fetchFieldsForExcel(catId, subCatId, kpiId);
//     if (!fullStructure || fullStructure.length === 0) {
//       showAlert("Full field structure not found");
//       return;
//     }

//     const months = [
//       "April", "May", "June", "July", "August", "September",
//       "October", "November", "December", "January", "February", "March"
//     ];
//     const monthToYearMap = {};
//     months.forEach(month => {
//       monthToYearMap[month] = ["January", "February", "March"].includes(month)
//         ? endYear
//         : startYear;
//     });

//     const grouped = {};
//     fullStructure.forEach(field => {
//       const groupKey = field?.group?.[0] || "Unknown";
//       const groupLabel = STATIC_GROUPS?.water?.[groupKey] || groupKey;
//       if (!grouped[groupLabel]) grouped[groupLabel] = [];
//       grouped[groupLabel].push(field);
//     });

//     const excelData = [];
//     let idCounter = 1;

//     for (const [groupLabel, fields] of Object.entries(grouped)) {
//       // Push group label row
//       excelData.push({},{
//         "Sr. No.": idCounter++,
//         KPIName: groupLabel,
//         "UOM": "",
//         ...Object.fromEntries(months.map(month => [`${month} ${monthToYearMap[month]}`, ""]))
//       });

//       // Push each field row under the group
//       fields.forEach(field => {
//         const fieldRow = {
//           "Sr. No.": "",
//           KPIName: `a. ${field.fieldName || "-"}`,
//           "UOM": "",
//         };

//         months.forEach(month => {
//           const expectedYear = String(monthToYearMap[month]);
//           const normalizedMonth = month.toLowerCase();

//           const match = approvedData.find(item =>
//             String(item.fieldId) === String(field.fieldId) &&
//             String(item.frequencyYear) === expectedYear &&
//             item.frequencyMonth?.toLowerCase() === normalizedMonth
//           );

//           fieldRow[`${month} ${expectedYear}`] = match ? match.prevValue : "";
//           if (match?.unitName) {
//             fieldRow["UOM"] = match.unitName;
//           }
//         });

//         excelData.push(fieldRow);
//       });
//     }

//     if (excelData.length === 0) {
//       showAlert("Nothing to export");
//       return;
//     }

//     //const worksheet = XLSX.utils.json_to_sheet(excelData);

//      const unitName = getCompanyUnitName?.() ?? "Unknown Unit";
    
//     // 1. Add header metadata (Client name, Location, etc.)
//     const sheetData = [
//       ["Client Name", "Harman Finochem Limited"],
//       ["Location", unitName],
//       [], // Empty row
//     ];
    
//     // 2. Create rows from excelData (which is array of objects)
//     if (excelData.length > 0) {
//       const headers = Object.keys(excelData.find(row => Object.keys(row).length > 0) || {});
    
//       // Push the header row
//       sheetData.push(headers);
    
//       // Push all the data rows
//       excelData.forEach(obj => {
//         const row = headers.map(h => obj[h] ?? "");
//         sheetData.push(row);
//       });
//     }
    
//     // 3. Create the worksheet and export
//     const worksheet = XLSX.utils.aoa_to_sheet(sheetData);

//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, "Water Monthly Summary");
//     XLSX.writeFile(workbook, `Water_KPI_Summary_${startYear}-${endYear}.xlsx`);

//     showAlert("Excel downloaded successfully", true);
//   } catch (err) {
//     console.error("Download error", err);
//     showAlert(err.message || "Failed to export");
//   } finally {
//     setIsExcelLoading(false);
//   }
// };


//calender year
// const handleExcelDownload = async () => {
//   setIsExcelLoading(true);
//   try {
//     const selectedYear = year;
//     // Fetch all approved water data for the selected companyUnit and year
//     const waterData = await fetchWaterByYear({ year: selectedYear, companyUnit, showAlert });
//     if (!waterData || waterData.length === 0) {
//       showAlert("No water data available for the selected year.");
//       return;
//     }
//     // All data returned is already approved and for the selected companyUnit
//     const approvedData = waterData;
//     const fullStructure = await fetchFieldsForExcel(catId, subCatId, kpiId);
//     if (!fullStructure || fullStructure.length === 0) {
//       showAlert("Full field structure not found");
//       return;
//     }
//     const months = [
//       "January", "February", "March", "April", "May", "June",
//       "July", "August", "September", "October", "November", "December"
//     ];
//     const grouped = {};
//     fullStructure.forEach(field => {
//       const groupKey = field?.group?.[0] || "Unknown";
//       const groupLabel = STATIC_GROUPS?.water?.[groupKey] || groupKey;
//       if (!grouped[groupLabel]) grouped[groupLabel] = [];
//       grouped[groupLabel].push(field);
//     });
//     const excelData = [];
//     let idCounter = 1;
//     for (const [groupLabel, fields] of Object.entries(grouped)) {
//       // Push group label row
//       excelData.push({}, {
//         "Sr. No.": idCounter++,
//         KPIName: groupLabel,
//         "UOM": "",
//         ...Object.fromEntries(months.map(month => [`${month} ${selectedYear}`, ""])),
//         Total: ""
//       });
//       // Track group totals for each month and overall
//       const groupMonthTotals = {};
//       let groupTotalSum = 0;
//       months.forEach(month => {
//         groupMonthTotals[month] = 0;
//       });
//       // Push each field row under the group
//       fields.forEach(field => {
//         const fieldRow = {
//           "Sr. No.": "",
//           KPIName: `a. ${field.fieldName || "-"}`,
//           "UOM": "",
//         };
//         let totalSum = 0;
//         months.forEach(month => {
//           const monthIndex = months.indexOf(month) + 1; // 1-based month
//           const expectedYear = String(selectedYear);
//           // Monthly records
//           const monthlySum = approvedData
//             .filter(item =>
//               String(item.fieldId) === String(field.fieldId) &&
//               item.frequencyType === "Monthly" &&
//               String(item.frequencyYear) === expectedYear &&
//               item.frequencyMonth?.toLowerCase() === month.toLowerCase()
//             )
//             .reduce((sum, item) => sum + (Number(item.prevValue) || 0), 0);
//           // Daily records
//           const dailySum = approvedData
//             .filter(item => {
//               if (
//                 String(item.fieldId) !== String(field.fieldId) ||
//                 item.frequencyType !== "Daily" ||
//                 !item.frequencyDate
//               ) return false;
//               const date = new Date(item.frequencyDate);
//               return (
//                 date.getFullYear() === Number(selectedYear) &&
//                 date.getMonth() + 1 === monthIndex
//               );
//             })
//             .reduce((sum, item) => sum + (Number(item.prevValue) || 0), 0);
//           const total = monthlySum + dailySum;
//           fieldRow[`${month} ${selectedYear}`] = total > 0 ? Number(total).toFixed(2) : "";
//           totalSum += total;
//           groupMonthTotals[month] += total;
//           // Set unit only once
//           if (!fieldRow["UOM"]) {
//             const match = approvedData.find(item => String(item.fieldId) === String(field.fieldId) && ((item.frequencyType === "Monthly" && String(item.frequencyYear) === expectedYear && item.frequencyMonth?.toLowerCase() === month.toLowerCase()) || (item.frequencyType === "Daily" && item.frequencyDate && new Date(item.frequencyDate).getFullYear() === Number(selectedYear) && new Date(item.frequencyDate).getMonth() + 1 === monthIndex)));
//             if (match?.unitName) {
//               fieldRow["UOM"] = match.unitName;
//             }
//           }
//         });
//         fieldRow["Total"] = totalSum > 0 ? Number(totalSum).toFixed(2) : "";
//         groupTotalSum += totalSum;
//         excelData.push(fieldRow);
//       });
//       // Add summary row for group totals
//       const groupSummaryRow = {
//         "Sr. No.": "",
//         KPIName: `${groupLabel} Total` ,
//         "UOM": "",
//       };
//       months.forEach(month => {
//         groupSummaryRow[`${month} ${selectedYear}`] = groupMonthTotals[month] > 0 ? Number(groupMonthTotals[month]).toFixed(2) : "";
//       });
//       groupSummaryRow["Total"] = groupTotalSum > 0 ? Number(groupTotalSum).toFixed(2) : "";
//       excelData.push(groupSummaryRow);
//     }
//     if (excelData.length === 0) {
//       showAlert("Nothing to export");
//       return;
//     }
//     const unitName = getCompanyUnitName?.() ?? "Unknown Unit";
//     const sheetData = [
//       ["Client Name", "Harman Finochem Limited"],
//       ["Location", unitName],
//       [], // Empty row
//     ];
//     if (excelData.length > 0) {
//       const headers = Object.keys(excelData.find(row => Object.keys(row).length > 0) || {});
//       sheetData.push(headers);
//       excelData.forEach(obj => {
//         const row = headers.map(h => obj[h] ?? "");
//         sheetData.push(row);
//       });
//     }
//     const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, "Water Monthly Summary");
//     XLSX.writeFile(workbook, `Water_KPI_Summary_${selectedYear}.xlsx`);
//     showAlert("Excel downloaded successfully", true);
//   } catch (err) {
//     console.error("Download error", err);
//     showAlert(err.message || "Failed to export");
//   } finally {
//     setIsExcelLoading(false);
//   }
// };
  
    const handleExcelDownload = async () => {
  setIsExcelLoading(true);
  try {
    const selectedYear = year;
    // Fetch all approved water data for the selected companyUnit and year
    const waterData = await fetchWaterByYear({ year: selectedYear, companyUnit, showAlert });
    if (!waterData || waterData.length === 0) {
      showAlert("No water data available for the selected year.");
      return;
    }
    // All data returned is already approved and for the selected companyUnit
    const approvedData = waterData;
    const fullStructure = await fetchFieldsForExcel(catId, subCatId, kpiId);
    if (!fullStructure || fullStructure.length === 0) {
      showAlert("Full field structure not found");
      return;
    }
    
    const months = [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];
    
    const grouped = {};
    fullStructure.forEach(field => {
      const groupKey = field?.group?.[0] || "Unknown";
      const groupLabel = STATIC_GROUPS?.water?.[groupKey] || groupKey;
      if (!grouped[groupLabel]) grouped[groupLabel] = [];
      grouped[groupLabel].push(field);
    });
    
    const excelData = [];
    let idCounter = 1;
    
    for (const [groupLabel, fields] of Object.entries(grouped)) {
      // Push group label row
      excelData.push({}, {
        "Sr. No.": idCounter++,
        KPIName: groupLabel,
        "UOM": "",
        ...Object.fromEntries(months.map(month => [`${month} ${selectedYear}`, ""])),
        Total: ""
      });
      
      // Track group totals for each month and overall
      const groupMonthTotals = {};
      let groupTotalSum = 0;
      months.forEach(month => {
        groupMonthTotals[month] = 0;
      });
      
      // Push each field row under the group
      fields.forEach(field => {
        const fieldRow = {
          "Sr. No.": "",
          KPIName: `a. ${field.fieldName || "-"}`,
          "UOM": "",
        };
        
        const expectedYear = String(selectedYear);
        
        // Check if this field has yearly data first
        const yearlyData = approvedData.find(item =>
          String(item.fieldId) === String(field.fieldId) &&
          item.frequencyType === "Yearly" &&
          String(item.frequencyYear) === expectedYear
        );
        
        let totalSum = 0;
        let hasYearlyData = false;
        
        if (yearlyData && yearlyData.prevValue && Number(yearlyData.prevValue) > 0) {
          // Handle yearly data
          hasYearlyData = true;
          const yearlyValue = Number(yearlyData.prevValue);
          totalSum = yearlyValue;
          
          // Approach 1: Show yearly value only in Total column, leave months empty
          months.forEach(month => {
            fieldRow[`${month} ${selectedYear}`] = "";
          });
          
          // Set unit from yearly data
          if (yearlyData?.unitName) {
            fieldRow["UOM"] = yearlyData.unitName;
          }
          
        } else {
          // Handle monthly/daily data (existing logic)
          months.forEach(month => {
            const monthIndex = months.indexOf(month) + 1; // 1-based month
            
            // Monthly records
            const monthlySum = approvedData
              .filter(item =>
                String(item.fieldId) === String(field.fieldId) &&
                item.frequencyType === "Monthly" &&
                String(item.frequencyYear) === expectedYear &&
                item.frequencyMonth?.toLowerCase() === month.toLowerCase()
              )
              .reduce((sum, item) => sum + (Number(item.prevValue) || 0), 0);
            
            // Daily records
            const dailySum = approvedData
              .filter(item => {
                if (
                  String(item.fieldId) !== String(field.fieldId) ||
                  item.frequencyType !== "Daily" ||
                  !item.frequencyDate
                ) return false;
                
                const date = new Date(item.frequencyDate);
                return (
                  date.getFullYear() === Number(selectedYear) &&
                  date.getMonth() + 1 === monthIndex
                );
              })
              .reduce((sum, item) => sum + (Number(item.prevValue) || 0), 0);
            
            const total = monthlySum + dailySum;
            fieldRow[`${month} ${selectedYear}`] = total > 0 ? Number(total).toFixed(2) : "";
            totalSum += total;
            groupMonthTotals[month] += total;
            
            // Set unit only once
            if (!fieldRow["UOM"]) {
              const match = approvedData.find(item => 
                String(item.fieldId) === String(field.fieldId) && 
                ((item.frequencyType === "Monthly" && 
                  String(item.frequencyYear) === expectedYear && 
                  item.frequencyMonth?.toLowerCase() === month.toLowerCase()) || 
                 (item.frequencyType === "Daily" && 
                  item.frequencyDate && 
                  new Date(item.frequencyDate).getFullYear() === Number(selectedYear) && 
                  new Date(item.frequencyDate).getMonth() + 1 === monthIndex))
              );
              if (match?.unitName) {
                fieldRow["UOM"] = match.unitName;
              }
            }
          });
        }
        
        // Set total value
        fieldRow["Total"] = totalSum > 0 ? Number(totalSum).toFixed(2) : "";
        groupTotalSum += totalSum;
        
        // Add to group totals only if not yearly data (to avoid double counting)
        if (!hasYearlyData) {
          // Monthly totals already added in the loop above
        } else {
          // For yearly data using Approach 1, we don't add to monthly totals
          // The group total will include the yearly value
        }
        
        excelData.push(fieldRow);
      });
      
      // Add summary row for group totals
      const groupSummaryRow = {
        "Sr. No.": "",
        KPIName: `${groupLabel} Total`,
        "UOM": "",
      };
      
      months.forEach(month => {
        groupSummaryRow[`${month} ${selectedYear}`] = groupMonthTotals[month] > 0 ? 
          Number(groupMonthTotals[month]).toFixed(2) : "";
      });
      groupSummaryRow["Total"] = groupTotalSum > 0 ? Number(groupTotalSum).toFixed(2) : "";
      excelData.push(groupSummaryRow);
    }
    
    if (excelData.length === 0) {
      showAlert("Nothing to export");
      return;
    }
    
    const unitName = getCompanyUnitName?.() ?? "Unknown Unit";
    const sheetData = [
      ["Client Name", "Harman Finochem Limited"],
      ["Location", unitName],
      [], // Empty row
    ];
    
    if (excelData.length > 0) {
      const headers = Object.keys(excelData.find(row => Object.keys(row).length > 0) || {});
      sheetData.push(headers);
      excelData.forEach(obj => {
        const row = headers.map(h => obj[h] ?? "");
        sheetData.push(row);
      });
    }
    
    const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Water Monthly Summary");
    XLSX.writeFile(workbook, `Water_KPI_Summary_${selectedYear}.xlsx`);
    showAlert("Excel downloaded successfully", true);
    
  } catch (err) {
    console.error("Download error", err);
    showAlert(err.message || "Failed to export");
  } finally {
    setIsExcelLoading(false);
  }
};

  

  const columns = React.useMemo(
    () => [
      { Header: "Sr No", Cell: ({ row: { _index } }) => _index + 1 },
      {
        Header: "Frequency Type",
        Cell: ({
          row: {
            _original: { frequencyType },
          },
        }) => frequencyType || "-",
      },
      {
        Header: "Frequency Date",
        Cell: ({
          row: {
            _original: { frequencyDate },
          },
        }) => frequencyDate || "-",
      },
      {
        Header: "Frequency Month",
        Cell: ({
          row: {
            _original: { frequencyMonth },
          },
        }) => frequencyMonth || "-",
      },
      {
        Header: "Frequency Year",
        Cell: ({
          row: {
            _original: { frequencyYear },
          },
        }) => frequencyYear || "-",
      },

      {
        Header: "Updated By",
        width: 150,
        Cell: ({
          row: {
            _original: { updater, creater, updatedAt },
          },
        }) => {
          const updaterName = updater?.first_name
            ? `${updater.first_name} ${updater.last_name}`
            : creater?.first_name
            ? `${creater.first_name} ${creater.last_name}`
            : "-";
          const formattedDate = updatedAt
            ? new Date(updatedAt).toLocaleDateString("en-GB")
            : "";

          return (
            <div>
              <div>{updaterName}</div>
              {formattedDate && (
                <div style={{ fontSize: "0.8em", color: "gray" }}>
                  ({formattedDate})
                </div>
              )}
            </div>
          );
        },
      },
      {
        Header: "Status",
        Cell: ({
          row: {
            _original: { approvalStatus },
          },
        }) => (approvalStatus === "approved" ? "Approved" : "Pending" || "-"),
      },
      {
        Header: "Approved By",
        width: 150,
        Cell: ({
          row: {
            _original: { approver, approvedAt },
          },
        }) => {
          const approverName = approver?.first_name
            ? `${approver.first_name} ${approver.last_name}`
            : "-";
          const formattedDate = approvedAt
            ? new Date(approvedAt).toLocaleDateString("en-GB")
            : "";

          return (
            <div>
              <div>{approverName}</div>
              {formattedDate && (
                <div style={{ fontSize: "0.8em", color: "gray" }}>
                  ({formattedDate})
                </div>
              )}
            </div>
          );
        },
      },
      {
        Header: "View",
        Cell: ({
          row: {
            _original: { formId, approvalStatus },
          },
        }) => (
          <span
            onClick={() => {
              navigate(isLoggedIn ? "/company/data" : "/admin/data", {
                state: { formId, page: "water", store: "waterStore" , approvalStatus: approvalStatus},
              });
            }}
            className="btn btn-primary btn-sm btn-action waves-effect waves-light"
          >
            View
          </span>
        ),
      },

      {
        Header: "Log",
        Cell: ({
          row: {
            _original: { formId },
          },
        }) => (
          <i
            type="button"
            onClick={() => handleModalLogShow(formId)}
            className="mdi mdi-dots-vertical"
          ></i>
        ),
      },

       // {
      //   Header: "Actions",
      //   width: 270,
      //   Cell: ({
      //     row: {
      //       _original: { formId, approvalStatus },
      //     },
      //   }) => (
      //     <div style={{ display: "flex", gap: "10px" }}>
      //       {approvalStatus === ApprovalEnums.Approved ? (
      //         <span>-</span>
      //       ) : (
      //         <>
      //           {user.role === USER_ROLE.Company || kpi.isApproved ? (
      //             <>
      //               <button
      //                 className="btn btn-success btn-sm"
      //                 onClick={() => handleModalOpen("approve", formId)}
      //               >
      //                 Approve
      //               </button>
      //               <button
      //                 className="btn btn-primary btn-sm btn-action waves-effect waves-light"
      //                 onClick={() =>
      //                   navigate("/company/approve/environment", {
      //                     state: {
      //                       formId,
      //                       groupConstant: "water",
      //                       type: "water",
      //                       kpiName,
      //                     },
      //                   })
      //                 }
      //               >
      //                 Edit
      //               </button>
      //               <button
      //                 className="btn btn-danger btn-sm"
      //                 onClick={() => handleModalOpen("delete", formId)}
      //               >
      //                 Delete
      //               </button>
      //             </>
      //           ) : (
      //             <>
      //               {kpi && (
      //                 <>
      //                   {kpi.isEdited && (
      //                     <button
      //                       className="btn btn-primary btn-sm btn-action waves-effect waves-light"
      //                       onClick={() =>
      //                         navigate("/company/approve/environment", {
      //                           state: {
      //                             formId,
      //                             groupConstant: "water",
      //                             type: "water",
      //                             kpiName,
      //                             year,
      //                           },
      //                         })
      //                       }
      //                     >
      //                       Edit
      //                     </button>
      //                   )}
      //                 </>
      //               )}
      //             </>
      //           )}
      //         </>
      //       )}
      //     </div>
      //   ),
      // },
//   {
//   Header: "Actions",
//   width: 270,
//   Cell: ({
//     row: {
//       _original: { formId, approvalStatus },
//     },
//   }) => (
//     <div style={{ display: "flex", gap: "10px" }}>
//       {approvalStatus !== ApprovalEnums.Approved ? (
//         user.role === USER_ROLE.Company ? (
//           <>
//             <button
//               className="btn btn-success btn-sm"
//               onClick={() => handleModalOpen("approve", formId)}
//             >
//               Approve
//             </button>
//             <button
//               className="btn btn-primary btn-sm btn-action waves-effect waves-light"
//               onClick={() =>
//                 navigate("/company/approve/environment", {
//                   state: {
//                     formId,
//                     groupConstant: "water",
//                     type: "water",
//                     kpiName,
//                   },
//                 })
//               }
//             >
//               Edit
//             </button>
//             <button
//               className="btn btn-danger btn-sm"
//               onClick={() => handleModalOpen("delete", formId)}
//             >
//               Delete
//             </button>
//           </>
//         ) : (
//           <span>-</span>
//         )
//       ) : (
//         user.role === USER_ROLE.Company ? (
//           <button
//             className="btn btn-danger btn-sm"
//             onClick={() => handleModalOpen("delete", formId)}
//           >
//             Delete
//           </button>
//         ) : (
//           <span>-</span>
//         )
//       )}
//     </div>
//   ),
// },

{
  Header: "Actions",
  width: 270,
  Cell: ({
    row: {
      _original: { formId, approvalStatus },
    },
  }) => (
    <div style={{ display: "flex", gap: "10px" }}>
      {approvalStatus === ApprovalEnums.Approved ? (
        <>
          {user.role === USER_ROLE.Company || user.department === "Admin" ? (
            <button
              className="btn btn-danger btn-sm"
              onClick={() => handleModalOpen("delete", formId)}
            >
              Delete
            </button>
          ) : (
            <span>-</span>
          )}
        </>
      ) : (
        <>
          {user.role === USER_ROLE.Company || user.department === "Admin" || kpi.isApproved ? (
            <>
              <button
                className="btn btn-success btn-sm"
                onClick={() => handleModalOpen("approve", formId)}
              >
                Approve
              </button>
              <button
                className="btn btn-primary btn-sm btn-action waves-effect waves-light"
                onClick={() =>
                  navigate("/company/approve/environment", {
                    state: {
                      formId,
                      groupConstant: "water",
                      type: "water",
                      kpiName,
                      year,
                    },
                  })
                }
              >
                Edit
              </button>
              <button
                className="btn btn-danger btn-sm"
                onClick={() => handleModalOpen("delete", formId)}
              >
                Delete
              </button>
            </>
          ) : (
            <>
              {kpi?.isEdited && (
                <button
                  className="btn btn-primary btn-sm btn-action waves-effect waves-light"
                  onClick={() =>
                    navigate("/company/approve/environment", {
                      state: {
                        formId,
                        groupConstant: "water",
                        type: "water",
                        kpiName,
                        year,
                      },
                    })
                  }
                >
                  Edit
                </button>
              )}
            </>
          )}
        </>
      )}
    </div>
  ),
}

    ],
    [navigate, isLoggedIn, kpiName, kpi, user.role]
  );

 

  // useEffect(() => {
  //   fetchForms({ type: "water", page, pageSize: 10, filter: { year } });
   
    
  // }, [fetchForms, page, year]);

  //with companyunit
  useEffect(() => {
    fetchForms({
      type: "water",
      page,
      pageSize: 12,
      filter: { year, companyUnit },
    });
  }, [fetchForms, page, year, companyUnit]);
  


  // const getYearFilter = (year, type) => {
  //   if (type === "calendar") {
  //     return {
  //       frequencyYear: [year],
  //       frequencyMonth: ['1','2','3','4','5','6','7','8','9','10','11','12'],
  //     };
  //   }
  //   return {
  //     frequencyYear: [year, year + 1],
  //     frequencyMonth: ['4','5','6','7','8','9','10','11','12','1','2','3'],
  //   };
  // };
  

  // const getFinancialYearFilter = (year, companyUnit) => ({
  //   frequencyYear: [year, year + 1],
  //   frequencyMonth: ['4','5','6','7','8','9','10','11','12','1','2','3'],
  //   companyUnit
  // });
  
  // useEffect(() => {
  //   fetchForms({
  //     type: "water",
  //     page,
  //     pageSize: 10,
  //     filter: getFinancialYearFilter(year, companyUnit),
  //   });
  // }, [fetchForms, page, year, companyUnit]);


  // const getCalendarYearFilter = (year, companyUnit) => ({
  //   frequencyYear: String(year),
  //   companyUnit,
  // });
  
  // useEffect(() => {
  //   fetchForms({
  //     type: "emission",
  //     page,
  //     pageSize: 10,
  //     filter: getCalendarYearFilter(year, companyUnit),
  //   });
  // }, [fetchForms, page, year, companyUnit]);
  

  useEffect(() => {
    fetchUnits();
  }, [fetchUnits]);

  const handleView = (formId) => {
    navigate(isLoggedIn ? "/company/data" : "/admin/data", {
      state: { formId, page: "water", store: "waterStore" },
    });
  };

  
useEffect(() => {
  console.log("user.role:", user.role);
  console.log("USER_ROLE.Company:", USER_ROLE.Company);
}, [user.role]);

  const handleEdit = (formId) =>
    navigate("/company/approve/environment", {
      state: {
        formId,
        groupConstant: "water",
        type: "water",
        kpiName,
        year,
      },
    });


const monthOrderMap = {
  April: 3, May: 4, June: 5, July: 6, August: 7, September: 8,
      October: 9, November: 10, December: 11, January: 0, February: 1, March: 2,
};

    const sortedRecords = [...(forms?.records || [])].sort((a, b) => {
      const monthA = monthOrderMap[a.frequencyMonth] ?? 99;
      const monthB = monthOrderMap[b.frequencyMonth] ?? 99;
    
      const yearA = Number(a.frequencyYear);
      const yearB = Number(b.frequencyYear);
    
      // First sort by year (if needed), then month order
      if (yearA !== yearB) {
        return yearA - yearB;
      }
    
      return monthA - monthB;
    });
      console.log('Water Table Data:', sortedRecords);


  return (
    <Layout>
      <div className="water-list">
        <div className="container-fluid">
          {/* Page Title */}
          <div className="row">
            <div className="col-12">
              <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 className="mb-sm-0 font-size-18">Water</h4>
                <div className="page-title-right">
                  {isLoggedIn && (
                    <div
                      style={{
                        display: "flex",
                        marginLeft: "auto",
                        width: "fit-content",
                      }}
                    >
                      <div className="text-sm-end d-flex gap-1 flex-wrap">
                        <Performance label="Water" />
                        <Financials
                          groups={["A", "B", "C"].map((ele) => ({
                            group: ele,
                            label: FINANCIALS_LABELS.water[ele],
                          }))}
                          guidance={PERMISSBLE_LIMIT_GUIDANCE}
                          key="financials"
                          units={units?.filter((e) =>
                            ["Mega liter", "Kilo Liter", "Meter cube"].includes(
                              e.name
                            )
                          )}
                        />
                        <Link to={`/${path}/add-water`}>
                          <button
                            type="button"
                            data-bs-toggle="modal"
                            data-bs-target="#newCustomerModal"
                            className="btn btn-secondary waves-effect waves-light addCustomers-modal "
                          >
                            <i className="mdi mdi-plus me-1"></i> Add water
                          </button>
                        </Link>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          {/* End Page Title */}

          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "20px",
            }}
          >
            {Object.entries(STATIC_GROUPS.water).map(
              ([group, title], index) => (
                <div
                  style={{
                    flex: "1 1 calc(50% - 20px)",
                    boxSizing: "border-box",
                  }}
                  key={group}
                >
                  <DashboardHistogram
                    index={index}
                    title={title}
                    group={group}
                    reportType="water"
                  />
                </div>
              )
            )}
          </div>
          <div className="row mt-4">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                  {/* <div className="row mb-2 align-items-center">
                    <div className="col-xl-3">
                      <label className="form-label">
                        Filter data on Annual basis
                      </label>
                      <div className="d-flex gap-2">
                        <select
                          className="form-select"
                          value={year || new Date().getFullYear()}
                          onChange={(event) =>
                            setYear(Number(event.target.value))
                          }
                        >
                          {Array.from({ length: 5 })
                            .map((_, i) => new Date().getFullYear() - i)
                            .map((v) => (
                              <option key={v} value={v}>{`FY ${v}-${
                                v + 1
                              }`}</option>
                            ))}
                        </select>
                        <button
                          className="btn btn-success"
                          onClick={handleExcelDownload}
                          disabled={isExcelLoading}
                        >
                          {isExcelLoading ? (
                            <span>
                              <i className="mdi mdi-loading mdi-spin me-1"></i>
                              Loading...
                            </span>
                          ) : (
                            <span>
                              <i className="mdi mdi-file-excel me-1"></i>
                              Download Excel
                            </span>
                          )}
                        </button>
                      </div>
                    </div>
                  </div> */}

{/* <div className="row mb-3 align-items-end g-3">
  <div className="col-md-6 col-xl-4">
    <label className="form-label fw-semibold">
      Filter data on Annual basis
    </label>
    <select
      className="form-select"
      value={year || new Date().getFullYear()}
      onChange={(event) => setYear(Number(event.target.value))}
    >
      {Array.from({ length: 5 })
        .map((_, i) => new Date().getFullYear() - i)
        .map((v) => (
          <option key={v} value={v}>{`FY ${v}-${v + 1}`}</option>
        ))}
    </select>
  </div>

  <div className="col-md-6 col-xl-4 d-flex">
    <button
      type="button"
      className="btn btn-success ms-auto"
      onClick={handleExcelDownload}
    >
      <i className="mdi mdi-download me-1"></i> Download Excel
    </button>
  </div>
</div> */}


<div className="container">
  {/* First Row: Dropdown */}
  <div className="row mb-4">
    <div className="col-12 col-md-6 col-xl-4">
      <label className="form-label fw-semibold mb-2">
        Filter data on Annual basis
      </label>
      <select
        className="form-select"
        value={year || new Date().getFullYear()}
        onChange={(event) => setYear(Number(event.target.value))}
      >
        {Array.from({ length: 5 })
          .map((_, i) => new Date().getFullYear() - i)
          .map((v) => (
            <option key={v} value={v}>{`CY ${v}`}</option>
          ))}
      </select>
    </div>
  </div>

  {/* Second Row: Button */}
  <div className="row mb-4">
    <div className="col-12 col-md-6 col-xl-4">
      <button
        type="button"
        className="btn btn-success"
        onClick={handleExcelDownload}
      >
        <i className="mdi mdi-download me-1"></i> Download Excel
      </button>
    </div>
  </div>
</div>




                  <div className="table  dashboard-table">
                    {/* <DynamicTable
                      pageSize={forms?.records?.length || 0}
                      columns={columns}
                      data={forms?.records || []}
                    /> */}
                    <DynamicTable
                      pageSize={sortedRecords.length}
                      columns={columns}
                      data={sortedRecords}
                    />

                  </div>
                  <MobileTable
                    handleModalOpen={handleModalOpen}
                    handleView={handleView}
                    handleEdit={handleEdit}
                  />
                  <PaginationControls
                    totalPages={forms?.totalPages}
                    page={page}
                    setPage={setPage}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Existing component code */}

        <Modal
          show={showModal}
          onHide={handleModalClose}
          size={modalType === "log" ? "xl" : ""}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {modalType === "approve"
                ? "Approve Form"
                : modalType === "delete"
                ? "Delete Form"
                : "Log Details"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ overflow: "hidden" }}>
            {modalType === "approve" && (
              <p>Are you sure you want to approve this form?</p>
            )}
            {modalType === "delete" && (
              <p>
                Are you sure you want to delete this form? Once deleted, all
                data associated with this form will be permanently removed and
                cannot be recovered.
              </p>
            )}
            {modalType === "log" && (
              <div style={{ overflowX: "auto" }}>
                <table className="table table-responsive scroll">
                  <thead>
                    <tr key={12} className="waterTabletr">
                      <th key={0}>Username</th>
                      <th key={1}>Date</th>
                      <th key={2}>Action</th>
                      <th key={3}>Ip</th>
                      <th key={4}>Request</th>
                    </tr>
                  </thead>
                  <LogTableBody logRaw={logRaw} formId={selectedFormId}/>
                </table>
              </div>
            )}
          </Modal.Body>

          <Modal.Footer>
            <Button variant="secondary" onClick={handleModalClose}>
              Cancel
            </Button>
            {modalType === "approve" && (
              <Button variant="primary" onClick={handleConfirmAction}>
                Approve
              </Button>
            )}
            {modalType === "delete" && (
              <Button variant="primary" onClick={handleConfirmAction}>
                Delete
              </Button>
            )}
          </Modal.Footer>
        </Modal>
      </div>
    </Layout>
  );
};

export default observer(WaterDashboardPage);
